<template>
  <div>
    <b-row>
      <b-col cols="6">
        <b-card header-tag="header" style="height: 45rem;">
          <template v-slot:header>
            <h6 class="mb-0">Historic Predictive Risk Indicators</h6>
          </template>
          <b-row class="text-center">
            <b-col cols="12">
              <b-avatar variant="success" text=" "></b-avatar>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <p>An online search of both initial and drill down results for XX key terms most often associated with Anti-Bribery & Corruption has resulted in:</p>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <h2>Chart</h2>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <p>Results in conjunction with [Third Party Name]. This is predicative of a [low] risk indicator for Anti-Bribery & Corruption.</p>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <p
                class="text-danger"
              >Please note that the Anti-Bribery & Corruption Historic Predictive Risk Indicator indicates only the potential for risk. It should not be used in isolation and should be used in combination with your organisation's own risk assessment, procedures and policies.</p>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="6">
        <b-card header-tag="header" style="height: 45rem;">
          <template v-slot:header>
            <h6 class="mb-0">Future Predictive Risk Benchmarks</h6>
          </template>
          <b-row class="text-center">
            <b-col cols="12">
              <b-avatar variant="warning" text=" "></b-avatar>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <p>A search of [Third Party Name]’s domain has revealed the bellow results in conjunction with visibility of and preparedness for Anti-Bribery & Corruption Compliance.</p>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <h6>Bribery & Corruption</h6>
              <p>Chart</p>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <h6>Political Exposure</h6>
              <p>Chart</p>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <h6>Fraud</h6>
              <p>Chart</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <p
                class="text-danger"
              >Please note that the Anti-Bribery & Corruption Future Predicative Risk Benchmarks indicate only the prevalence of material related to ta risk area. This is not a comprehensive policy review. Should you wish for such a service please contact us to discuss.</p>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "AntiBriberiyPredictiveRisk",
  data() {
    return {};
  }
};
</script>